var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGraphBarIncreaseOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.07715 19.8883L34.8743 7.24661",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6775 5.28857L34.8743 7.24646L32.9406 12.4433",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1071 36.7114H30.0642V19.7914C30.0642 19.4709 30.1916 19.1635 30.4181 18.9368C30.6448 18.7102 30.9523 18.5829 31.2728 18.5829H34.8985C35.219 18.5829 35.5265 18.7102 35.7532 18.9368C35.9797 19.1635 36.1071 19.4709 36.1071 19.7914V36.7114Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0214 36.7114H17.9785V23.4171C17.9785 23.0966 18.1059 22.7892 18.3325 22.5626C18.5591 22.3359 18.8666 22.2086 19.1871 22.2086H22.8128C23.1333 22.2086 23.4408 22.3359 23.6674 22.5626C23.894 22.7892 24.0214 23.0966 24.0214 23.4171V36.7114Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9357 36.7114H5.89282V27.0429C5.89282 26.7223 6.02015 26.4149 6.24681 26.1883C6.47346 25.9616 6.78086 25.8343 7.10139 25.8343H10.7271C11.0476 25.8343 11.3551 25.9616 11.5817 26.1883C11.8083 26.4149 11.9357 26.7223 11.9357 27.0429V36.7114Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGraphBarIncreaseOutline);
export default __webpack_public_path__ + "static/media/icon_graph_bar_increase_outline.8ec066d97c524fd56a0d867dca2910e7.svg";
export { ForwardRef as ReactComponent };